import { useCallback, useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import {
  useQuizAssessmentTestDataProvider
} from '../../../../providers/data-provider/quiz-assessment-test.data.provider';

// Loads the test's answer change log while the dialog is open and clears it when closed.
export function useTestChangeLog(testId, open) {
  const [changeLog, setChangeLog] = useState([]);
  const { getTestDetails } = useQuizAssessmentTestDataProvider();
  const notify = useNotify();

  const loadChangeLog = useCallback(() => {
    return getTestDetails(testId)
      .then((res) => {
        setChangeLog(res.data?.changeLogs ?? []);
      })
      .catch(() => {
        notify('Erro ao carregar o histórico de edições', 'warning');
      });
  }, [getTestDetails, testId, notify]);

  useEffect(() => {
    if (!open) {
      setChangeLog([]);
      return;
    }
    loadChangeLog();
  }, [open, testId]);

  return { changeLog, reload: loadChangeLog };
}
